import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Error404 from '~/pages/404/404';
import usePortalContext from '~/contexts/portal';
import FlexPage, { isFlexPage, LayoutUsingData } from '~/pages/flex-page/flex-page';
import { GeneralPageFromSlug } from '~/pages/general/general';
import { usePageDataFromRoute, FlexPageUsingItsOwnLayout, NonFlexPageUsingDefaultLayout, DetailsRoutes, isNoDataPage } from './page-routes';
import { assertDefined } from '~/helpers/data';
import { ImportedPage } from './page-loaders';
// eslint-disable-next-line complexity
export function RouteAsPortalOrNot() {
    var _a;
    const { name, data, hasError, other } = usePageDataFromRoute();
    const { portalPrefix, setPortal } = usePortalContext();
    if (!data) {
        return null;
    }
    if (hasError) {
        return React.createElement(Error404, null);
    }
    const isFlex = !hasError && isFlexPage(data);
    const isPortal = isFlex && ((_a = data.layout[0]) === null || _a === void 0 ? void 0 : _a.type) === 'landing';
    if (isPortal) {
        if (portalPrefix !== `/${name}`) {
            setPortal(assertDefined(name));
            return null;
        }
        if (!other) {
            return React.createElement(FlexPageUsingItsOwnLayout, { data: data });
        }
        if (isNoDataPage(other)) {
            return (React.createElement(LayoutUsingData, { data: data },
                React.createElement(ImportedPage, { name: other })));
        }
        return (React.createElement(LayoutUsingData, { data: data },
            React.createElement(Routes, null,
                React.createElement(Route, { path: "/details/*", element: React.createElement(DetailsRoutes, null) }),
                React.createElement(Route, { path: "/:dir/*", element: React.createElement(PortalSubRoute, null) }))));
    }
    setPortal('');
    if (isFlex) {
        if (other) {
            // Non-portal flex pages do not have children; keep it canonical
            return React.createElement(Navigate, { to: `/${name}` });
        }
        return React.createElement(FlexPageUsingItsOwnLayout, { data: data });
    }
    return React.createElement(NonFlexPageUsingDefaultLayout, { data: data });
}
function PortalSubRoute() {
    const { name, data, hasError } = usePageDataFromRoute();
    if (hasError) {
        return React.createElement(Error404, null);
    }
    if (isFlexPage(data)) {
        return React.createElement(FlexPage, { data: assertDefined(data) });
    }
    if (data === null || data === void 0 ? void 0 : data.body) {
        return React.createElement(GeneralPageFromSlug, { slug: `spike/${data === null || data === void 0 ? void 0 : data.meta.slug}` });
    }
    return React.createElement(ImportedPage, { name: assertDefined(name) });
}
